import React, { useState } from 'react';
import { useAsync } from 'react-use';
import { useTranslation } from 'react-i18next';
import { get } from 'lodash';
import { connect } from 'redux-zero/react';
import { combineActions } from 'redux-zero/utils';
import { DsTag, DsIcon, DsLoader } from '@tokenyico/design-system/dist/reactJS';
import { MessageService } from 'services';
import { formActions, holderActions } from 'app/state/actions';
import { datetimeFormat } from '@tokenyico/design-system';

const MessageDetail = ({ setError, selectedMessage, setMessages, holder: { selectedToken } }) => {
  const { t } = useTranslation();
  const [bodyMessage, setBodyMessage] = useState();

  useAsync(async () => {
    try {
      if (selectedMessage) {
        setBodyMessage(null);
        const messageId = get(selectedMessage, 'text.id');
        const mailbox = get(selectedToken, 'address');
        const {
          text: { html },
        } = await MessageService.getMessage(messageId, mailbox);
        setBodyMessage(html);

        // update unseen messages
        const messages = await MessageService.getAllMessages(mailbox);
        setMessages(messages);
      }
    } catch (e) {
      setError(e);
    }
  }, [selectedMessage]);

  const recipientsLabel =
    selectedMessage && selectedMessage.to.length > 1
      ? `${get(selectedMessage, 'to[0].address')}, + ${selectedMessage.to.length - 1}`
      : get(selectedMessage, 'to[0].address');

  const handleDownloadFile = async (file) => {
    const mailbox = get(selectedToken, 'address');
    return MessageService.getAttachement(file, mailbox);
  };

  return (
    <>
      {selectedMessage && (
        <div className="_flex:column _p:x(5) _p:y(4)">
          <h1 className="h3 _text(400) _m:bottom(3)">{get(selectedMessage, 'subject')}</h1>
          <div className="_flex:row _flex:align(center) _m:bottom(5)">
            {get(selectedMessage, 'sent') ? (
              <>
                <span className="_m:right(3) _text(500)">{t('shared.to')}</span>
                <DsTag
                  label={recipientsLabel}
                  isSquare={true}
                  version="info"
                  size="md"
                  className="_text-overflow:ellipsis"
                  style={{ maxWidth: '15rem' }}
                />
              </>
            ) : (
              <>
                <span className="_m:right(2) _text(500)">{t('shared.from')}</span>
                <DsTag
                  label={get(selectedMessage, 'from.address')}
                  isSquare={true}
                  version="info"
                  size="md"
                  className="_text-overflow:ellipsis"
                  style={{ maxWidth: '15rem' }}
                />
              </>
            )}
          </div>
          <div
            className="_flex:column"
            style={{ width: '100%', backgroundColor: 'var(--grey-200)' }}
          >
            <div
              className="_flex:row _flex:justify(space-between) _flex:align(center) _p:x(4) _p:y(3)"
              style={{ width: '100%', borderBottom: '1px solid var(--grey-400)' }}
            >
              <span className="_text:sm _text-grey-900">
                {datetimeFormat(selectedMessage.date)}
              </span>
              <DsTag
                label={`${t('shared.sentBy')} ${get(selectedMessage, 'from.address')}`}
                version="info"
                className="_text-overflow:ellipsis"
                style={{ maxWidth: '12rem' }}
              />
            </div>

            {bodyMessage ? (
              <div
                className="_p(4)"
                style={{ lineHeight: '1.5rem' }}
                dangerouslySetInnerHTML={{
                  __html: bodyMessage,
                }}
              />
            ) : (
              <div className="_p(4) _m:x(auto)">
                <DsLoader version="dots" color="var(--blue-500)" />
              </div>
            )}

            {selectedMessage.attachments && (
              <>
                <hr />
                <div className="_grid _flex:align(center) _p:x(4) _p:y(3) _text:sm">
                  {selectedMessage.attachments.map((file) => (
                    <div
                      className="_col(12) _flex:align(center) _m:bottom(4)"
                      key={file.id}
                      onClick={() => handleDownloadFile(file)}
                      style={{ color: 'var(--blue-700)', cursor: 'pointer' }}
                    >
                      <DsIcon name="download" size="12px" className="_m:right(2)" />
                      <span>{file.filename}</span>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

const mapToProps = (state) => state;
export default connect(mapToProps, combineActions(formActions, holderActions))(MessageDetail);
